import { render, staticRenderFns } from "./FeedbackSuccess.vue?vue&type=template&id=32d399a8&scoped=true"
import script from "./FeedbackSuccess.vue?vue&type=script&lang=js"
export * from "./FeedbackSuccess.vue?vue&type=script&lang=js"
import style0 from "./FeedbackSuccess.vue?vue&type=style&index=0&id=32d399a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d399a8",
  null
  
)

export default component.exports